import { jsx as _jsx } from "react/jsx-runtime";
export function Skeleton({ width = '100%', height = '20px', borderRadius = 'var(--radius-md)', }) {
    return (_jsx("div", { role: "status", "aria-label": "Loading", style: {
            width,
            height,
            borderRadius,
            background: `linear-gradient(
          90deg,
          var(--color-bg-elevated) 25%,
          var(--color-border) 50%,
          var(--color-bg-elevated) 75%
        )`,
            backgroundSize: '200% 100%',
            animation: 'shimmer 1.5s ease-in-out infinite',
        } }));
}
//# sourceMappingURL=Skeleton.js.map